import React, { useState } from "react";
import plusImage from "../../../static/images/plus.svg";
import { useTranslation } from "react-i18next";
import { subString, loadingHtml, errorContainer } from "../utils/functions";
import SecondaryButton from "canvas-core-react/lib/SecondaryButton";
import Modal from "./customModal";
import IconInfoUniversal from "canvas-core-react/lib/IconInfoUniversal";
import * as instanceActions from "../../Redux/api";
import * as sessionActions from "../../Redux/actions/sessionActions";
import TokenComponent from "../shared/token";
import { useDispatch } from "react-redux";

const defaultModal = { show: false, content: null };
const defaultToken = { show: false, code: null };

const fileUpdload = ({ needToken, postUrl, redirect }) => {
  const [token, setToken] = useState(defaultModal);
  const [selectedFile, setSelectedFile] = useState(null);
  const [modal, setModal] = useState(defaultModal);

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleSelect = (event) => {
    if (event.target.files[0]) setSelectedFile(event.target.files[0]);
  };

  const printButtons = () => {
    let clearBtn = { className: "btnLimpiar" };
    let uploadBtn = { id: "btn-upload-file", className: "btnAgregar" };

    if (selectedFile !== null && !(needToken && token.show)) {
      clearBtn.onClick = () => setSelectedFile(null);
      uploadBtn.onClick = saveFile;
    } else {
      clearBtn.disabled = true;
      uploadBtn.disabled = true;
    }

    return (
      <>
        <SecondaryButton {...clearBtn}>
          {t("general.buttons.clear")}
        </SecondaryButton>
        <SecondaryButton {...uploadBtn}>
          {t("general.buttons.upload")}
        </SecondaryButton>
      </>
    );
  };

  const saveFile = ({ validToken = null }) => {
    if (needToken) {
      if (validToken === null) setToken({ show: true, code: null });
      else {
        setToken({ show: true, code: validToken });
        updateFile(validToken);
      }
    } else updateFile();
  };

  const openModal = (content) => setModal({ show: true, content });

  const closeModal = () => setModal(defaultModal);

  const formatResponse = (data, success = false) => {
    openModal(
      errorContainer(
        <div className="fix-modal-desing-title d-flex align-items-center">
          <IconInfoUniversal size={18} /> <h3>Carga de Facturas</h3>
        </div>,
        data.data?.message,
        {
          continueBtn: {
            text: t("general.buttons.close"),
            action: () => {
              closeModal();
              setSelectedFile(null);
              setToken(defaultToken);
              if (success && redirect) redirect();
            },
          },
        }
      )
    );
  };

  const updateFile = async (code) => {
    openModal(loadingHtml());
    const data = new FormData();
    data.append("file", selectedFile);

    const apiHeader = code ? { "x-security-code": code } : {};

    try {
      const response = await dispatch(
        instanceActions.instanceAction(`${postUrl}`, "post", data, apiHeader)
      );

      formatResponse(response, true);
    } catch (err) {
      switch (err.response.status) {
        case 401:
          dispatch(sessionActions.logout());
          break;
        default:
          formatResponse(err.response);
          break;
      }
    }
  };

  return (
    <>
      <div className="file-container">
        <div className="provider-button">
          <label htmlFor="file-upload" className="custom-file-upload">
            <img src={plusImage} className="plusIcon" />
            <i className="fa fa-cloud-upload"></i>{" "}
            {selectedFile !== null
              ? subString(selectedFile.name)
              : `${t("general.labels.uploadFile")}`}
          </label>
          <input
            id="file-upload"
            type="file"
            multiple
            accept=".csv"
            onChange={handleSelect}
            onClick={(e) => (e.target.value = null)}
            disabled={token.show}
          />
        </div>
        <div className="form-actions clearfix">{printButtons()}</div>
      </div>
      <Modal show={modal.show}>{modal.content}</Modal>
      {needToken && token.show && (
        <TokenComponent
          send={updateFile}
          goBack={() => setToken(defaultToken)}
        />
      )}
    </>
  );
};

export default fileUpdload;
